/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { endUser } from "../assets/end-user";
import { Icon, type IconBaseProps } from "../icon";

export const IconEndUser = (props: IconBaseProps) => <Icon {...props} svg={endUser} />;

IconEndUser.displayName = "IconEndUser";
